import {BillingGroupSimpleSerializer, InsuranceCompanySerializer, PayerSerializer, PaymentSaveSerializer, PaymentSerializer} from '../@core/api.service';
import {GetterCache} from '../utils/accessor.utils';
import {ModelBase} from './model-base';

export class Payment extends ModelBase implements PaymentSerializer {
    id?: number;
    payer?: PayerSerializer;
    primary_remit_count?: number;
    secondary_remit_count?: number;
    payer_type?: number;
    created_at?: Date | string;
    modified_at?: Date | string;
    origin?: string;
    transaction_id?: string;
    transaction_handling_code?: string;
    monetary_amount?: number;
    credit_debit_flag?: string;
    payment_method_code?: string;
    payment_format_code?: string;
    payer_dfi_qualifier?: string;
    payer_dfi_id?: string;
    payer_account_number?: string;
    payer_account_number_qualifier?: string;
    originating_company_id?: string;
    receiver_dfi_qualifier?: string;
    receiver_dfi_id?: string;
    receiver_account_number_qualifier?: string;
    receiver_account_number?: string;
    payer_name?: string;
    date?: Date | string;
    provider_npi?: string;
    created_by?: number;
    hl7_message?: number;
    billing_group?: BillingGroupSimpleSerializer;
    remit_total_amount?: number;
    insurance_company?: InsuranceCompanySerializer;

    assign(x: PaymentSerializer) {
        super.assign(x);
        this.monetary_amount = Math.round((x.monetary_amount || 0) * 100) / 100;
    }

    static getInsuranceCompanyName(x: PaymentSerializer | PaymentSaveSerializer) {
        return x.payer_type === 2 ? 'Patient' : ((x as PaymentSerializer).insurance_company?.name);
    }

    @GetterCache()
    get insuranceCompanyDisplayName() {
        return Payment.getInsuranceCompanyName(this);
    }

    static getIsManuallyAdded(x: PaymentSerializer) {
        return !!x.created_by;
    }

    @GetterCache()
    get isManuallyAdded() {
        return Payment.getIsManuallyAdded(this);
    }

    static getSourceText(x: PaymentSerializer) {
        return this.getIsManuallyAdded(x) ? 'Added Manually' : 'Received Electronically';
    }

    @GetterCache()
    get sourceText() {
        return Payment.getSourceText(this);
    }
}
